import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  campaigns: Array<ICampaign>;
}

export function useSearchCampaignsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/search",
  });
}
